<template>
    <div>
        <h1 class="display-heading">Medical Report Details</h1>
        <div class="card mb-3">
            <div class="card-body">
                <medical-report-detail
                    :reportType="reportType"
                    :uploadDate="reportDate"
                    :reportDescription="reportDescription"
                    :docIds="docIds">
                </medical-report-detail>
            </div>
        </div>

        <router-link class="btn btn-primary btn-primary-insv" :to="{'name': detailPath}">
            Back to Medical Report List
        </router-link>
    </div>
</template>

<script>
import medicalReportDetail from '@/components/medical-report';
export default {
    'name': 'UserMedicalReportDetail',
    'components': {
        medicalReportDetail
    },
    'computed': {
        medicalReportId () {
            return this.$route.params.id;
        },
        isFamily () {
            return this.$route.name === 'family-medical-report-detail';
        },
        detailPath () {
            if (this.isFamily) {
                return 'family-medical-report';
            }
            return 'user-medical-report';
        }
    },
    data () {
        return {
            'reportType': null,
            'reportDate': null,
            'reportDescription': null,
            'reportDownloadUrl': null,
            'docIds': []
        };
    },
    mounted () {
        this.axios.get('MedicalReport/GetReportById', {
            'params': {
                'reportId': this.medicalReportId
            }
        }).then(({ data }) => {
            this.reportType = data.data ? data.data.rt : null;
            this.reportDate = data.data ? data.data.ud : null;
            this.reportDescription = data.data ? data.data.rd : null;
            this.docIds = data.data ? data.data.d : [];
        });
    }
};

</script>

<style>

</style>
